<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">CRM REPORTS</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <strong> Member Balance Points Report </strong>
            </div>
            <div class="row mt-3">
              <div class="col-lg-4 col-md-12 col-12">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    From
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <Datepicker
                      :enableTimePicker="false"
                      class="date-time-dashboad"
                      v-model="searchForm.from_date"
                      :format="format"
                      auto-apply
                      :clearable="false"
                      :min-date="new Date(new Date().setFullYear(new Date().getFullYear() - 1))"
                      :max-date="new Date()"
                      @update:model-value="onChangeFromDate"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-12 pt-custtom">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    To
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <Datepicker
                      :enableTimePicker="false"
                      class="date-time-dashboad"
                      v-model="searchForm.to_date"
                      :format="format"
                      auto-apply
                      :clearable="false"
                      :min-date="searchForm.from_date"
                      :max-date="new Date()"
                      @update:model-value="onChangeToDate"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-lg-12 col-md-12 col-12">
                <div class="row">
                  <div
                    class="col-lg-1 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    Search
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <input
                      class="nosubmit"
                      type="search"
                      id="keyword_search"
                      v-model="searchForm.search_keyword"
                      name="keyword_search"
                      placeholder="Enter member ID, name, phone number ..."
                      @keydown.enter="handleSearchEnter"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4 ps-3">
              <div class="col-lg-9 col-md-9 col-3 d-flex">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle btn-sm"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                  >
                    Download
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('csv')"
                        href="#"
                        >Export CSV</a
                      >
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('xlsx')"
                        href="#"
                        >Export Excel</a
                      >
                    </li>
                  </ul>
                </div>
                <div style="margin-left: 3vh">
                  <material-button
                    class="btn-background btn-sm"
                    @click="search()"
                    style="width: 162.52px"
                  >
                    Search
                  </material-button>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder">
                              Row No
                            </th>
                            <th class="text-center font-weight-bolder">
                              Member ID
                            </th>
                            <th class="text-center font-weight-bolder">
                              Member Name
                            </th>
                            <th class="text-center font-weight-bolder">
                              Phone No
                            </th>
                            <th class="text-center font-weight-bolder">
                              Points Earned
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="members.length">
                          <tr v-for="(value, key) in members" :key="key">
                            <td class="text-center text-xss">
                              {{ (pagination.per_page || 0) * ((pagination.current_page || 1) - 1) + key + 1 }}
                            </td>
                            <td class="text-center text-xss">
                              {{ value.member_id_format }}
                            </td>
                            <td class="text-center text-xss">
                              {{ value.member_name }}
                            </td>
                            <td class="text-center text-xss">
                              {{ value.phone_number }}
                            </td>
                            <td
                              class="text-center text-xss"
                              :class="{ 'text-danger': value.points_earned < 0 }"
                            >
                              {{ value.points_earned_format }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="5" class="text-center">
                              No members found
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <pagination
                    v-if="pagination.last_page > 1"
                    :pagination="pagination"
                    :current_page="pagination.current_page"
                    :last_page="pagination.last_page"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>

    <!-- Hidden Export Form -->
    <form
      :action="`${actionDownload}/merchant/download-member-balance-points-report`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="search_keyword" :value="searchForm.search_keyword" />
      <input type="hidden" name="from_date" :value="dateFormat(searchForm.from_date)" />
      <input type="hidden" name="to_date" :value="dateFormat(searchForm.to_date)" />
      <input type="hidden" name="action" value="export" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="checkExport" :value="checkExport" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import Pagination from "@/components/Pagination.vue";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import DashboardReportService from "../../services/dashboardReport.service";
import TokenService from "../../services/token.service";
import CommonFunctionService from "../../services/commonFunction.service";
import $ from "jquery";

export default {
  name: "member-balance-points-report",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    Pagination,
    Datepicker,
  },
  data() {
    return {
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      members: [],
      pagination: {},
      page: 1,
      action_export: "csv",
      checkExport: false,
      snackbar: null,
      message: "",
      loaderActive: false,
      searchForm: {
        search_keyword: "",
        from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        to_date: new Date(),
        page: 1,
      },
    };
  },
  created() {
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    this.getList(this.page);
  },
  methods: {
    getList(page) {
      this.showLoader();
      this.searchForm.page = page;

      const params = {
        ...this.searchForm,
        from_date: this.dateFormat(this.searchForm.from_date),
        to_date: this.dateFormat(this.searchForm.to_date),
      };

      DashboardReportService.getDataMemberBalancePointsReport(params).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.members = response.data.data.items || [];
            this.pagination = response.data.data || {};
            this.page = this.pagination.current_page || 1;
            this.checkExport = true;
            this.hideLoader();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message =
            error.response?.data?.result?.message ||
            "An error occurred while fetching data";
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    search() {
      this.page = 1;
      this.getList(this.page);
    },
    handleSearchEnter() {
      this.search();
    },
    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },
    dateFormat(date) {
      if (!date) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    onChangeFromDate(from_date) {
      this.searchForm.from_date = from_date;
      if (
        !this.searchForm.to_date ||
        moment(this.searchForm.to_date) < moment(from_date)
      ) {
        this.searchForm.to_date = new Date();
      }
    },
    onChangeToDate(to_date) {
      this.searchForm.to_date = to_date;
    },
    exportFile(type = "csv") {
      this.action_export = type;
      setTimeout(() => {
        $("#downloadForm").click();
      }, 150);
    },
    closeSnackbar() {
      this.snackbar = null;
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
};
</script>

<style scoped>
.message-success {
  z-index: 9999;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

@media only screen and (max-width: 991px) {
  .pt-custtom {
    padding-top: 7px;
  }
}
</style>
